import React, { useEffect, useRef } from 'react'
import { useMotionPreferences } from '../../../context/MotionPreferencesContext'
import styles from './GradientBlob.module.css'

/**
 * GradientBlob - Animated gradient blobs that create depth and movement
 *
 * These are large, colorful, blurred shapes that float and morph,
 * creating a modern, dynamic background effect seen on sites like
 * Linear, Vercel, Stripe, etc.
 */
const GradientBlob = ({ className = '' }) => {
  const containerRef = useRef(null)
  const { reducedMotion } = useMotionPreferences()

  return (
    <div className={`${styles.container} ${className}`} ref={containerRef}>
      {/* Primary blob - large, moves slowly */}
      <div
        className={`${styles.blob} ${styles.blob1}`}
        style={{
          '--size': '600px',
          '--duration': reducedMotion ? '0s' : '25s',
        }}
      />

      {/* Secondary blob - different color, opposite movement */}
      <div
        className={`${styles.blob} ${styles.blob2}`}
        style={{
          '--size': '500px',
          '--duration': reducedMotion ? '0s' : '20s',
        }}
      />

      {/* Accent blob - smaller, faster */}
      <div
        className={`${styles.blob} ${styles.blob3}`}
        style={{
          '--size': '400px',
          '--duration': reducedMotion ? '0s' : '15s',
        }}
      />

      {/* Extra accent blob */}
      <div
        className={`${styles.blob} ${styles.blob4}`}
        style={{
          '--size': '350px',
          '--duration': reducedMotion ? '0s' : '18s',
        }}
      />

      {/* Noise overlay for texture */}
      <div className={styles.noise} />
    </div>
  )
}

export default GradientBlob
